<template>
    <q-page class="">
        <div class="q-display-1">Wiadomości PUSH</div>

        <push-template
            :isNew="true"
            v-if="showAddEditor"
            @save="save"
            @cancel="cancel">
        </push-template>

        <br>

        <push-template
            v-for="model in $store.getters.pushTemplate"
            :key="model.id"
            :model="model"
            @save="save"
            @cancel="cancel"
            @remove="confirmAndDelete(model)"
            @send="m => send(m)"
            class="q-ma-sm">
        </push-template>

        <fixed-buttons>
            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="add_circle"
                class="q-pa-sm"
                color="primary"
                :disabled="showAddEditor"
                @click="addNew">
                <q-tooltip anchor="top left">
                    Dodaj
                </q-tooltip>
            </q-btn>
        </fixed-buttons>

    </q-page>
</template>
<script>
    import QEditor from 'quasar-framework/src/components/editor/QEditor'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QChipsInput from 'quasar-framework/src/components/chips-input/QChipsInput'
    import QDatetime from 'quasar-framework/src/components/datetime/QDatetime'
    import QField from 'quasar-framework/src/components/field/QField'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import FixedButtons from './FixedButtons'
    import PushTemplate from './PushTemplate'

    export default {
        name: 'Push',
        data () {
            return {
                showAddEditor: false
            }
        },
        components: {
            PushTemplate,
            FixedButtons, QTooltip, QCardActions, QCardMain, QField, QDatetime, QChipsInput, QBtn, QEditor},
        mounted () {
            this.$store.dispatch('fetchAll', {
                what: 'pushTemplate'
            })
        },
        methods: {
            addNew () {
                this.showAddEditor = true
            },
            cancel () {
                this.showAddEditor = false
            },
            save (model) {
                const item = {
                    id: this.$uuid(),
                    text: model.text
                }

                this.$store.dispatch('create', {
                    what: 'pushTemplate',
                    item,
                    id: item.id
                }).then(() => {
                    this.showAddEditor = false
                })
            },
            send (model) {
                const item = {
                    title: model.title,
                    message: model.text,
                    payload: {
                        messageType: 1,
                        title: model.title,
                        message: model.text,
                    }
                }

                this.$store.dispatch('create', {
                    what: 'pushMessage',
                    dontfetch: true,
                    force: true,
                    item
                })
            },
            confirmAndDelete (model) {
                this.$q.dialog({
                    title: `Potwierdź usunięcie szablonu`,
                    message: `Czy na pewno usunąć szablon?`,
                    ok: 'Usuń',
                    cancel: 'Anuluj',
                    position: 'top',
                }).then(() => {
                    this.$store.dispatch('remove', {
                        what: 'pushTemplate',
                        id: model.id
                    })
                }).catch(() => {

                })
            },
        },
    }
</script>